import type { App } from 'vue'
import type { I18n, I18nOptions } from 'vue-i18n'

import { createI18n } from 'vue-i18n'
import { setHtmlPageLang, setLoadLocalePool } from './helper'
import { localeSetting } from 'framework/settings/localeSetting'
import { LOCALE_KEY } from 'framework/enums/cacheEnum'
import type { LocaleSetting } from 'framework/types/config'

const { fallback, availableLocales } = localeSetting

export let i18n: ReturnType<typeof createI18n>

async function createI18nOptions(): Promise<I18nOptions> {
  let lsLocaleSetting: any = ''
  try {
    lsLocaleSetting = ((localStorage.getItem(LOCALE_KEY) &&
      JSON.parse(localStorage.getItem(LOCALE_KEY))) ||
      localeSetting) as LocaleSetting
  } catch (error) {
    if (error?.message?.indexOf('JSON') > -1) {
      lsLocaleSetting = localeSetting
      localStorage.setItem(LOCALE_KEY, JSON.stringify({ ...lsLocaleSetting }))
    }
  }

  const locale = lsLocaleSetting.locale
  const defaultLocal = await import(`./lang/${locale}.ts`)
  const message = defaultLocal.default?.message ?? {}

  setHtmlPageLang(locale)
  setLoadLocalePool((loadLocalePool) => {
    loadLocalePool.push(locale)
  })

  return {
    legacy: false,
    locale,
    fallbackLocale: fallback,
    messages: {
      [locale]: message,
    },
    availableLocales: availableLocales,
    sync: true, //If you don’t want to inherit locale from global scope, you need to set sync of i18n component option to false.
    silentTranslationWarn: true, // true - warning off
    missingWarn: false,
    silentFallbackWarn: true,
  }
}

// setup i18n instance with glob
export async function setupI18n(app: App) {
  const options = await createI18nOptions()
  i18n = createI18n(options) as I18n
  app.use(i18n)
}
